import TablaProcesos from "./tablas/tabla";
import "../../../shared/styles/ViewContainer.css";

const GestionProcesos = ({
  onClick,
  onChange,
  data,
  params,
  sort,
  setSort,
}) => {
  return (
    <div className="view-container">
      <div className="view-header">
        <h3 className="view-title">GESTIÓN DE PROCESOS</h3>
      </div>

      <div style={{
        background: 'linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)',
        borderRadius: '16px',
        padding: '20px',
        marginBottom: '24px',
        border: '1px solid #E2E8F0'
      }}>
        <div className="d-flex gap-3 align-items-center flex-wrap">
          <div style={{ minWidth: '250px' }}>
            <label className="form-label fw-bold mb-2" style={{ fontSize: '0.875rem', color: '#475569' }}>
              ESTADO
            </label>
            <select
              className="form-select"
              style={{
                borderRadius: '10px',
                border: '1px solid #CBD5E1',
                padding: '10px 14px',
                fontSize: '0.95rem'
              }}
              name="estado"
              onChange={(e) => onChange(e)}
            >
              <option value="todos">Todos</option>
              <option value="inactivo">Inactivo</option>
              <option value="activo">Activo</option>
              <option value="juicio">Juicio</option>
            </select>
          </div>

          <div style={{ flex: 1, minWidth: '300px' }}>
            <label className="form-label fw-bold mb-2" style={{ fontSize: '0.875rem', color: '#475569' }}>
              BUSCAR
            </label>
            <div className="search-group">
              <i className="bi bi-search search-icon"></i>
              <input
                type="text"
                className="search-input"
                id="input-search"
                placeholder="Buscar por persona"
                name="search"
                onKeyUp={(e) => {
                  if (e.code === "Enter") {
                    onChange(e, e.target.value);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="view-content">

        <div className="pagination-container fade-in">
          <div className="pagination-info">
            Total: {data?.total} registros
          </div>
          <div className="pagination-buttons">
            {data?.links.map((l, index) => {
              if (index == 0) {
                return (
                  <button
                    key={index}
                    className="pagination-btn"
                    name="anterior"
                    onClick={(event) => onClick(event)}
                  >
                    <i className="bi bi-arrow-left"></i>
                  </button>
                );
              }

              if (index == data?.links.length - 1) {
                return (
                  <button
                    key={index}
                    className="pagination-btn"
                    name="siguiente"
                    onClick={(event) => onClick(event)}
                  >
                    <i className="bi bi-arrow-right"></i>
                  </button>
                );
              }

              return (
                <button
                  key={index}
                  className={
                    params.page == l.label
                      ? "pagination-btn pagination-btn-active"
                      : "pagination-btn"
                  }
                  name="link"
                  onClick={(event) => onClick(event, l.label)}
                >
                  {l.label}
                </button>
              );
            })}
          </div>
        </div>

        <TablaProcesos
          onClick={onClick}
          onChange={onChange}
          data={data?.data}
          sort={sort}
          setSort={setSort}
        />
      </div>
    </div>
  );
};

export default GestionProcesos;
